export default __webpack_public_path__ + "static/media/bg-top.22b9d5d5.png";